<template>

    <box>
        <page-title>Hello World, this is my first styled component!</page-title>
        <cta>CTA</cta>
    </box>

</template>

<script>

export default {
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DesignSystemView.vue